
<mb-dialog>
  <mb-dialog-header>
    <h3 class="mb-dialog-custom__header text">
      <span [innerHtml]="dialogData?.hotelStatic?.name"></span>
      <mb-stars-rating [rating]="dialogData?.hotelStatic?.stars"></mb-stars-rating>
    </h3>
  </mb-dialog-header>
  <mb-dialog-body>
    <div class="mb-dialog-custom__body">
      <div *ngIf="dialogData?.searchFormService?.expiredBooking" class="mb-col-12">
        <mb-alert type="warning" arrow="down">
          <mb-alert-title
            i18n="@@modals_modifysearch_tu_busqueda_supero_el_tiempo_maximo_para_reservar"
            >Tu búsqueda superó el tiempo máximo para reservar</mb-alert-title
          >
          <mb-alert-description
            i18n="
              @@modals_modifysearch_por_favor_vuelve_a_realizar_la_busqueda_para_actualizar_la_disponibilidad"
            >Por favor vuelve a realizar la búsqueda para actualizar la
            disponibilidad</mb-alert-description
          >
        </mb-alert>
      </div>
      <div class="search-widget-container mb-col-12">
        <search-widget [section]="'detail'" [showStatus]="true" [isLanding]="'true'">
        </search-widget>
      </div>
    </div>
  </mb-dialog-body>
</mb-dialog>

